// extracted by mini-css-extract-plugin
module.exports = {"container":"redes-sociales_container__2Nc0E","socialIcon":"redes-sociales_socialIcon__1vGm-"};